import index from './'
import Create from './Create'
import Show from './Show'
import Sorting from './Sorting'

export default [
  {
    props: true,
    path: 'indicador',
    name: 'indicador.index',
    component: index,
    meta: { requiresAuth: true , label : 'Indicador' }
  },
  {
    props: true,
    path: 'indicador/sort',
    name: 'indicador.sort',
    component: Sorting,
    meta: { requiresAuth: true , label : 'Indicador Ordenação' }
  },
  {
    props: true,
    path: 'indicador/create',
    name: 'indicador.create',
    component: Create,
    meta: { requiresAuth: true , label : 'Indicador Novo' }
  },
  {
    props: true,
    path: 'indicador/:id',
    name: 'indicador.show',
    component: Show,
    meta: { requiresAuth: true , label : 'Indicador Visualizar' }
  }
]



// WEBPACK FOOTER //
// ./src/features/Indicador/routes.js